let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("f7WA2")).then(() => parcelRequire('czVUE'));